exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#noPatternsNotice {\r\n  position: absolute;\r\n  display: flex;\r\n  width: 100%;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n#noPatternsNotice span {\r\n  color: #ccc;\r\n  font-size: 20px;\r\n  font-weight: normal;\r\n  padding: 2rem 3rem;\r\n  border: 2px dashed #ddd;\r\n  border-radius: 10px;\r\n}\r\n#noPatternsNotice span .material-icons {\r\n  transform: rotate(-90deg)translateX(-0.75rem);\r\n  margin-left: 0.25rem;\r\n}", ""]);

// exports
